import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 2B75FE22-5209-4DF8-B16A-B6F74272337B
 * name checkbox-blank
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-blank.svg
 * tags
 * - Form 
 */
export const CheckboxBlankIcon = createSvgIcon(<><path d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" /></>, 'CheckboxBlankIcon');
export default CheckboxBlankIcon